import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Link from '@mui/material/Link';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@mui/material/Typography';
import {useTranslation} from 'react-i18next';

import {PS_INSTRUMENTS, formatInstrumentLabel} from '@explorer/util/filters';

const InstrumentFilter = props => {
  const {t} = useTranslation();

  return (
    <Box width="100%" marginTop={2}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        marginBottom={1}
      >
        <Typography component="span">
          {t('instrumentFilter.label', 'Instrument Type')}
        </Typography>
        <Link
          color="inherit"
          underline="always"
          variant="caption"
          href="https://developers.planet.com/docs/apis/data/sensors/"
          target="_blank"
          rel="noreferrer noopener"
        >
          {t('instrumentFilter.learnMore', 'Learn more')}
        </Link>
      </Box>
      <FormGroup
        aria-label="instruments"
        name="instrumentFilters"
        style={{marginLeft: 4}}
        data-qe="instrument-filter"
      >
        {Object.keys(PS_INSTRUMENTS).map(instrument => (
          <Box key={instrument}>
            <FormControlLabel
              value={instrument}
              checked={!!props.instruments[instrument]}
              control={
                <Checkbox
                  color="primary"
                  name={instrument}
                  onChange={props.onChange}
                  data-qe={`${instrument}-instrument-checkbox`}
                />
              }
              label={formatInstrumentLabel(instrument)}
              data-qe="instrument-checkbox"
            />
          </Box>
        ))}
      </FormGroup>
    </Box>
  );
};

InstrumentFilter.propTypes = {
  instruments: PropTypes.object.isRequired,
  onChange: PropTypes.func,
};

export default InstrumentFilter;
